import { render, staticRenderFns } from "./Gaia.vue?vue&type=template&id=2e43299a"
import script from "./Gaia.vue?vue&type=script&lang=js"
export * from "./Gaia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports